import { cineamoApiClient } from '../../apiClient';
import { ScreenDto } from '../../models/screen/ScreenDto.types';
import { ScreenInputDto } from '../../models/screen/ScreenInputDto.types';
import { ApiResponse } from '../../types/ApiResponse.types';

export async function getScreenById(id: number | string): Promise<ApiResponse<ScreenDto>> {
    return cineamoApiClient.get<ApiResponse<ScreenDto>>(`/screens/${id}`).then((response) => {
        return response.data;
    });
}

export async function setScreen(cinemaRoomId: number, screen: ScreenInputDto): Promise<ApiResponse<ScreenDto>> {
    return cineamoApiClient
        .put<ApiResponse<ScreenDto>>(`/cinema-rooms/${cinemaRoomId}/screen`, screen)
        .then((response) => {
            return response.data;
        });
}
